
import React, { useState, useEffect  } from 'react';
import './App.css';
import Primary_Navigation_Bar from './components/PrimaryNavigationBar';
import Header from './components/headers/Header';
import Biostatistics from './pages/Departments/Statistics and Data Science/Biostatistics';
import ScrollToTop from './components/scroll/ScrollToTop';
import Home from './pages/Home/Home';
import MedicalDevice from './pages/Regulatory Affairs/Medical Device/MedicalDevice';
import AboutUs from './pages/About Us/AboutUs';
import RealWorldEvidence from './pages/Research-Development/RealWorldEvidence';
import Footer from './components/footer/Footer';
import Contactus from './pages/ContactUs/Contactus';
import CDSCO from './pages/Regulatory Affairs/Medical Device/CDSCO/CDSCO';
import EU from './pages/Regulatory Affairs/Medical Device/EU/EU'
import Usfda from './pages/Regulatory Affairs/Medical Device/USFDA/Usfda'
import { Route, useLocation , Routes } from 'react-router-dom';
import ClinicalDataManagementServices from "./pages/Departments/Statistics and Data Science/ClinicalDataManagementServices";
import SEND from './pages/Departments/Send/Send'
import ToxicologicalServicesAndAssessment from "./pages/Research And Development/ToxicologicalServicesAndAssessment";
import Careers from "./pages/Careers/careers";
import CTApplications from "./pages/DiscoveryPhase/CTApplications";
import FlexDCOSEND from "./pages/CDISCStandardizationDataManagement/FlexDCOSEND/FlexDCOSEND";
import Product from "./pages/Products/Product";
import Aletheion from "./pages/Products/Aletheion/Aletheion";
import Nebula from "./pages/Products/Nebula/Nebula";
import PronoiaPatientIntelligence from "./pages/Products/PronoiaPatientIntelligence/PronoiaPatientIntelligence";
import CDASHSDTMADaMCDISC from "./pages/CDISCStandardizationDataManagement/CDASHSDTMADaMCDISC/CDASHSDTMADaMCDISC";
import StatRepIntAna from "./pages/CDISCStandardizationDataManagement/StatRepIntAna/StatRepIntAna";
import CommercializationServices from "./pages/EGCMA/CommercializationServices";
import BsSNS from "./pages/BSDDI/BsSNS";
import CMCBio from "./pages/RSCMC/CMCBio";
import CMCServices from "./pages/RSCMC/CMCServices";

function App() {
  return (
    <div className="App">
      <ScrollToTop/>
      <Primary_Navigation_Bar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/solutions/real-world-evidance' element={<RealWorldEvidence />} />
        <Route path='/AboutUs' element={<AboutUs />} />
        <Route path='/ContactUs' element={<Contactus />} />
        <Route path='/MedicalDevice' element={<MedicalDevice />} />
        <Route path='/Departments/Statistics-and-Data-Science/Clinical-Biostatistics' element={<Biostatistics />} />
        <Route path='/Departments/Statistics-and-Data-Science/Clinical-Data-Management-Services' element={<ClinicalDataManagementServices />} />
        <Route path='/Data-Management-and-CDISC-Standardization/Preclinical/SEND' element={<SEND />} />
        <Route path='/MedicalDevice/USFDA' element={<Usfda />} />
        <Route path='/MedicalDevice/EU' element={<EU />} />
        <Route path='/Product' element={<Product />} />
        <Route path='/CDISC-Standardization-&-Data-Management/Preclinical/Flexible-Data-Capture-Options-for-SEND-Compliance' element={<FlexDCOSEND />} />
        <Route path='/Discovery-Phase/Clinical/Clinical-Trial-Applications-with-Clinical-Studies-Operations' element={<CTApplications />} />
        <Route path='/MedicalDevice/CDSCO' element={<CDSCO />} />
        <Route path='/CDISC-Standardization-&-Data-Management/Clinical/CDASH-SDTM-ADaM-CDISC-Package' element={<CDASHSDTMADaMCDISC/>}/>
        <Route path='/CDISC-Standardization-&-Data-Management/Clinical/Statistical-Reporting-&-Integrated-Analyses' element={<StatRepIntAna/>}/>
        <Route path='/Biostatistics-&-Data-Driven-Inferences/Preclinical/Biostatistical-Support-for-Nonclinical-Studies' element={<BsSNS/>}/>
        <Route path='/Evidence-Generation-Commercialization-&-Market-Access/Commercialization-Services' element={<CommercializationServices/>}/>
        <Route path='/REGULATORY-AFFAIRS-AND-CMC/CMC-Biologics' element={<CMCBio/>}/>
        <Route path='/REGULATORY-AFFAIRS-AND-CMC/CMC-Services' element={<CMCServices/>}/>
        <Route path="/careers" element={<Careers />} />
          <Route path="/products/aletheion" element={<Aletheion />} />
          <Route path="/products/nebula" element={<Nebula />} />
          <Route
              path="/products/pronoia-patient-intelligence"
              element={<PronoiaPatientIntelligence />}
          />
        <Route path='/Research-and-Development/ToxicologicalServicesAndAssessment' element={<ToxicologicalServicesAndAssessment />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;